import { client } from "./index";

// Store owners: the business customers who buy websites (a franchise sees only its own)
export const getOwners = (params) => client.get("/admin/store-owners", { params });
export const createOwner = (payload) => client.post("/admin/store-owners", payload);
export const updateOwner = (ownerId, payload) => client.put(`/admin/store-owners/${ownerId}`, payload);
export const resetOwnerPassword = (ownerId) => client.post(`/admin/store-owners/${ownerId}/reset-password`);
// Super Admin: a customer who has not logged in for 6 months and has no running website (their websites go too)
// Super Admin only. confirmName must repeat the customer's name, as typed in the confirmation dialog.
export const deleteOwner = (ownerId, confirmName) => client.delete(`/admin/store-owners/${ownerId}`, { data: { confirmName } });
// Super Admin: a customer's staff, for "View as staff"
export const getOwnerStaff = (ownerId) => client.get(`/admin/store-owners/${ownerId}/staff`);
